import db from '../../config/databases/forms';
import getFormUpdatedAt from './getFormUpdatedAt';
import deleteImages from '../Image/deleteImages';
import refreshFormsList from './refreshFormsList';

// Delete a form
export default async function deleteForm(formId, force = false) {
  const res = await getFormUpdatedAt(formId);
  if (res !== null || force) {
    await db.forms.delete(parseInt(formId, 10));
    await deleteImages(formId);
    refreshFormsList();
    return true;
  }
  return false;
}
